{
    "dbp-modal": {
        "close": "Close"
    },
    "error": {
        "connection-to-server-refused": "Connection to server refused!",
        "summary": "An error occurred"
    }
}
